import { useMemo } from 'react';

import _ from 'lodash';

import { FormBuilderMethodType } from 'constants/formBuilder';
import { FormType } from 'constants/forms';

const useEditorShim = ({ request, dynamicFieldConfig, onInsert, onDelete }) =>
  useMemo(
    () => ({
      formType: FormType.HTML,
      execute: (method, payload) => {
        if (method === FormBuilderMethodType.DELETE_REACT_COMPONENT) {
          onDelete?.(payload);

          return;
        }

        onInsert?.(payload);
      },
      editing: {
        view: {
          focus: () => {
            request.onClose?.();
          },
        },
      },
      config: {
        get: key => {
          if (key === 'dynamicFieldConfig') {
            return dynamicFieldConfig;
          }

          return;
        },
      },
      commands: {
        get: () => ({ execute: _.noop }),
      },
    }),
    [request, dynamicFieldConfig, onInsert, onDelete],
  );

export default useEditorShim;
